function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M481-120q-17 0-28.5-11.5T441-160v-46q-45-10-79-35t-55-70q-7-14-.5-29.5T330-363q14-6 29 .5t23 21.5q17 30 43 45.5t64 15.5q41 0 69.5-18.5T587-356q0-35-22-55.5T463-458q-86-27-118-64.5T313-614q0-65 42-101t86-41v-44q0-17 11.5-28.5T481-840q17 0 28.5 11.5T521-800v44q38 6 66 24.5t46 45.5q9 13 3.5 29T614-634q-14 6-29 .5T557-653q-13-14-30.5-21.5T483-682q-44 0-67 19.5T393-614q0 33 30 52t104 40q69 20 104.5 63.5T667-358q0 71-42 108t-104 46v44q0 17-11.5 28.5T481-120z"
  }));
};
const SvgDollar = styled(BaseComponent).withConfig({
  displayName: "Dollar__SvgDollar",
  componentId: "sc-rwle9u-0"
})(["outline:none;"]);
SvgDollar.isIcon = true;
export default SvgDollar;